// ------
// Return Window Width
// ------

function windowWidth() {
	return window.innerWidth || document.documentElement.clientWidth;
}

// ------
// Slide Function
// ------
const slideUp = (target, duration) => {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${duration}ms`;
	target.style.boxSizing = 'border-box';
	target.style.height = `${target.offsetHeight}px`;
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
};

const slideDown = (target, duration, displayType) => {
	target.style.removeProperty('display');
	let { display } = window.getComputedStyle(target);
	display === 'none' ? (display = displayType) : null;
	target.style.display = display;
	target.style.display = display;
	const height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${duration}ms`;
	target.style.height = `${height}px`;
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
};

const slideToggle = (target, duration, displayType) => {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration, displayType);
	} else {
		return slideUp(target, duration, displayType);
	}
};

// ------
// Add scrollbar width
// ------
const getScrollbarWidth = () => {
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll';
	outer.style.msOverflowStyle = 'scrollbar';
	document.body.appendChild(outer);
	const inner = document.createElement('div');
	outer.appendChild(inner);
	const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
	outer.parentNode.removeChild(outer);
	document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);
};

getScrollbarWidth();

window.addEventListener('resize', () => {
	getScrollbarWidth();
});

// Toggle Menu Class
const toggleMenuClass = (toggle) => {
	document.body.classList.toggle('is-open-menu', toggle);
};

// Toggle Overlay Class
const toggleOverlayClass = (toggle) => {
	document.body.classList.toggle('show-overlay', toggle);
};

const toggleBodyScrollLock = (toggle) => {
	document.body.classList.toggle('noscroll', toggle);
};

// Attach Events
function attachEvent(selector, event, handler) {
	document.addEventListener(
		event,
		(ev) => {
			let { target } = ev;
			for (; target && target !== document; target = target.parentNode) {
				if (target.matches(selector)) {
					try {
						handler.call(target, ev);
					} catch (e) {
						console.error(e);
					}
					break;
				}
			}
		},
		false
	);
}

// Menu Hover
const menuLinks = document.querySelectorAll('.has-sub');
menuLinks.forEach((link) => {
	link.addEventListener('mouseenter', () => {
		toggleOverlayClass(true);
	});

	link.addEventListener('mouseleave', () => {
		toggleOverlayClass(false);
	});
});

// Add/Remove scrolling class
const addScrollingClass = () => {
	const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
	document.body.classList.toggle('is-scrolled', topOffset > 200);
};

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
	if (!ticking) {
		window.requestAnimationFrame(() => {
			addScrollingClass();
			ticking = false;
		});
		ticking = true;
	}
});

let lastScrollTop = 0;
window.addEventListener(
	'scroll',
	() => {
		const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
		document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
		lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
	},
	false
);

// Open mobile menu
const hamburger = document.querySelector('.hamburger');
if (hamburger) {
	hamburger.addEventListener('click', () => {
		const isOpen = document.body.classList.contains('is-open-menu');
		toggleMenuClass(!isOpen);
		toggleBodyScrollLock(!isOpen);
	});
}

// Open mobile sub menu
const menuArrow = document.querySelectorAll('.menu__arrow');

menuArrow.forEach((arrow) => {
	arrow.addEventListener('click', (el) => {
		if (windowWidth() < 1199) {
			const parent = el.target.closest('.menu__item');
			parent.classList.add('is-submenu-open');
		}
	});
});

const backButton = document.querySelectorAll('[data-menu-back]');
backButton.forEach((btn) => {
	btn.addEventListener('click', (el) => {
		if (windowWidth() < 1199) {
			const parent = el.target.closest('.menu__item');
			parent.classList.remove('is-submenu-open');
		}
	});
});

function closeAccordions() {
	const openAccordions = document.querySelectorAll('.accordion.is-open');
	openAccordions.forEach((openAccordion) => {
		const openContent = openAccordion.querySelector('.accordion__content');
		openAccordion.classList.remove('is-open');
		slideUp(openContent, 300);
	});
}

const accordionTitle = document.querySelectorAll('.accordion__title');
accordionTitle.forEach((title) => {
	title.addEventListener('click', (el) => {
		const accordionItem = el.target.closest('.accordion');
		const accordionContent = accordionItem.querySelector('.accordion__content');

		if (accordionItem.classList.contains('is-open')) {
			closeAccordions();
		} else {
			closeAccordions();
			accordionItem.classList.add('is-open');
			slideDown(accordionContent, 300, 'block');
		}
	});
});

// ------
// Steps Module
// ------

const stepElements = document.querySelectorAll('.steps-module__step');

stepElements.forEach((step, index) => {
	let stepTopBottomBorder = '45.1%';
	let stepLeftBorder = '100%';

	if (windowWidth() > 1199) {
		if (index % 2 !== 0) {
			stepTopBottomBorder = '46%';
		} else {
			stepTopBottomBorder = '35.5%';
		}
	} else if (windowWidth() < 1023) {
		stepTopBottomBorder = '44.5%';
	}

	if (index === stepElements.length - 1) {
		if (windowWidth() > 1919) {
			stepLeftBorder = 'calc(100% + 5px)';
		} else if (windowWidth() > 1199) {
			stepLeftBorder = 'calc(100% + 1px)';
		}
	} else {
		stepLeftBorder = '100%';
	}

	const topBorderEle = step.querySelector('.steps-module__step-border--top');
	const bottomBorderEle = step.querySelector('.steps-module__step-border--bottom');
	const leftBorderEle = step.querySelector('.steps-module__step-border--left');

	const stepTimeline = gsap.timeline({ paused: true });
	stepTimeline
		.to(topBorderEle, { width: stepTopBottomBorder, duration: 0.8 })
		.to(leftBorderEle, { height: stepLeftBorder, duration: 0.8 })
		.to(bottomBorderEle, { width: stepTopBottomBorder, duration: 0.8 });

	ScrollTrigger.create({
		trigger: step,
		start: 'top center',
		end: 'bottom center',
		animation: stepTimeline,
		scrub: true,
		stagger: 0.25
	});
});

// ------
// Scroll To Section
// ------
document.addEventListener('DOMContentLoaded', function () {
	const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;
	const secondaryNavHeight = document.querySelector('.secondary-nav')?.offsetHeight || 0;
	const scrollOffset = document.getElementById('scroll-offset');

	const totalOffset = headerHeight + secondaryNavHeight;
	scrollOffset?.style.setProperty('--scroll-height', `${totalOffset}px`);

	const smoothScroll = new scrollToSmooth('a', {
		targetAttribute: 'data-scrollto',
		duration: 1000,
		durationRelative: false,
		durationMin: false,
		durationMax: false,
		easing: easeInOutCubic,
		onScrollStart: (data) => {
			document.documentElement.style.scrollBehavior = 'initial';
		},
		onScrollUpdate: (data) => {},
		onScrollEnd: (data) => {
			document.documentElement.style.scrollBehavior = 'smooth';
		},
		offset: '#scroll-offset'
	});
	smoothScroll.init();
});

// ------
// Step form
// ------

const stepInputs = document.querySelectorAll('.steps-form-modal__answers-item input');
if (stepInputs.length > 0) {
	stepInputs.forEach((input) => {
		input.addEventListener('change', (el) => {
			const parent = el.target.closest('.steps-form-modal__list-item');
			const groupInputs = parent.querySelectorAll('input');
			const nextButton = parent.querySelector('.step-next');
			const atLeastOneChecked = Array.from(groupInputs).some((cb) => cb.checked);
			nextButton.classList.toggle('is-disabled', !atLeastOneChecked);
		});
	});

	const nextButtons = document.querySelectorAll('.steps-form-modal__btn-next');
	const prevButtons = document.querySelectorAll('.steps-form-modal__btn-prev');
	const steps = document.querySelectorAll('.steps-form-modal__list-item');
	const stepNavItems = document.querySelectorAll('.steps-form-modal__nav-item');
	const stepNav = document.querySelector('.steps-form-modal__nav');

	nextButtons.forEach((button, i) => {
		button.addEventListener('click', () => {
			navigateSteps(i, i + 1);
			updateNavItems(i + 1);
		});
	});

	prevButtons.forEach((button, i) => {
		button.addEventListener('click', () => {
			navigateSteps(i + 1, i);
			updateNavItems(i);
		});
	});

	function navigateSteps(currentIndex, nextIndex) {
		const currentStep = steps[currentIndex];
		const nextStep = steps[nextIndex];

		if (currentStep && nextStep) {
			currentStep.classList.remove('active');
			currentStep.classList.remove('completed');
			nextStep.classList.add('active');
		}
	}

	function updateNavItems(activeIndex) {
		stepNavItems.forEach((item, i) => {
			if (i === activeIndex) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
			if (i < activeIndex) {
				item.classList.add('completed');
			} else {
				item.classList.remove('completed');
			}
		});
	}

	// Final Submit
	const stepSubmitBtn = document.querySelector('.steps-form-modal__btn-submit');
	const resultStep = document.querySelector('.steps-form-modal__result');
	stepSubmitBtn.addEventListener('click', (btn) => {
		const parent = btn.target.closest('.steps-form-modal__list-item');
		parent.classList.remove('active');
		parent.classList.add('completed');
		resultStep.classList.add('active');
		updateNavItems(stepNavItems.length);
	});

	// Show form
	const showFormBtn = document.querySelector('.steps-form-modal__form-btn');
	const stepModalForm = document.querySelector('.steps-form-modal__form');
	showFormBtn.addEventListener('click', (btn) => {
		resultStep.classList.remove('active');
		stepModalForm.classList.add('active');
		stepNav.classList.add('hide');
	});

	// Open modal

	const toggleStepFormModal = (toggle) => {
		document.querySelector('.steps-form-modal')?.classList.toggle('is-open-modal', toggle);
		toggleBodyScrollLock(toggle);
	};

	const stepFormButton = document.querySelectorAll('.step-form-trigger');
	stepFormButton.forEach((button) => {
		button.addEventListener('click', () => {
			toggleStepFormModal(true);
		});
	});

	document.querySelectorAll('[data-close-step-modal]').forEach((element) => {
		element.addEventListener('click', () => {
			toggleStepFormModal(false);
		});
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			toggleStepFormModal(false);
		}
	});
}

// ------
// Secondary Nav
// ------

const secondaryNav = document.querySelector('.sec-secondary-nav');
if (secondaryNav) {
	ScrollTrigger.create({
		trigger: '.sec-secondary-nav',
		start: 'top 100px',
		endTrigger: '.page-end',
		end: 'bottom 50%+=100px',
		onToggle: (self) => {
			secondaryNav.classList.toggle('is-fixed', self.isActive);
		}
		// markers: true,
	});

	// Secondary Nav Slider
	const secondaryNavSlider = document.querySelector('[data-slider="secondary-nav-slider"]');

	const secondaryNavSliderOptions = {
		slidesPerView: 'auto',
		spaceBetween: 10,
		speed: 300,
		watchOverflow: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		breakpoints: {
			767: {
				spaceBetween: 20
			},
			1023: {
				spaceBetween: 20
			},
			1199: {
				spaceBetween: 20
			},
			1440: {
				spaceBetween: 35
			}
		}
	};

	const arrowRight = secondaryNavSlider.querySelector('.arrow-right');
	const arrowLeft = secondaryNavSlider.querySelector('.arrow-left');
	secondaryNavSliderOptions.navigation.nextEl = arrowRight;
	secondaryNavSliderOptions.navigation.prevEl = arrowLeft;
	const navSlider = new Swiper(secondaryNavSlider, secondaryNavSliderOptions);

	// Open Dropdown
	const secondaryNavDropdown = document.querySelectorAll('.secondary-nav__trigger');

	secondaryNavDropdown.forEach((btn) => {
		btn.addEventListener('click', (el) => {
			const parent = el.target.closest('.secondary-nav');
			parent.classList.toggle('is-open-dropdown');
		});
	});

	// Remove Class When Outside Click
	document.addEventListener('click', (event) => {
		const dropdowns = document.querySelectorAll('.secondary-nav__dropdown');
		dropdowns.forEach((dropdown) => {
			const parent = dropdown.closest('.secondary-nav');
			const trigger = parent.querySelector('.secondary-nav__trigger');
			if (parent.classList.contains('is-open-dropdown') && !parent.contains(event.target) && event.target !== trigger) {
				parent.classList.remove('is-open-dropdown');
			}
		});
	});

	const slideChange = (link) => {
		if (windowWidth() < 1199) {
			const currentSlide = link.getAttribute('data-item');
			navSlider.slideTo(currentSlide, 300);
		}
	};

	// Toggle active class
	const navLinks = document.querySelectorAll('.secondary-nav__link');
	navLinks.forEach((link) => {
		const linkId = link.getAttribute('href');

		if (linkId && linkId !== '#') {
			const sectionElem = document.querySelector(linkId);

			if (sectionElem) {
				gsap.timeline({
					scrollTrigger: {
						trigger: sectionElem,
						start: 'top center',
						end: 'bottom 20%',
						scrub: true,
						toggleClass: { targets: link, className: 'is-active' },
						onEnter: () => {
							slideChange(link);
						},
						onEnterBack: () => {
							slideChange(link);
						}
					}
				});
			}
		}
	});
}

// ------
// Lazy load init
// ------

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

// ------
// Mod Filter
// ------

const modFilter = document.querySelectorAll('.mod-filter');

// Isotope
const newsList = document.querySelector('.blog-list__grid');

if (newsList || modFilter) {
	var iso = new Isotope(newsList, {
		itemSelector: '.blog-list__grid-item',
		percentPosition: true,
		masonry: {
			columnWidth: '.grid-sizer'
		}
	});

	modFilter.forEach((filter) => {
		const filterButton = filter.querySelectorAll('.mod-filter__button');
		const dropdownTrigger = filter.querySelector('.mod-filter__dropdown-trigger ');
		const removeButton = filter.querySelector('.mod-filter__remove-btn');
		const removeButtonParent = filter.querySelector('.mod-filter__remove');
		let isFirstClick = true;

		filterButton.forEach((button) => {
			button.addEventListener('click', (ev) => {
				const filterValues = [];
				const parentEle = ev.target.closest('.mod-filter__button');
				const parentList = ev.target.closest('[data-filter-group]');
				parentEle.classList.toggle('is-selected');

				if (isFirstClick) {
					filter.classList.add('is-active');
					if (windowWidth() < 767) {
						slideDown(removeButtonParent, 300, 'block');
					}
					isFirstClick = false;
				}

				const anySelected = filter.querySelector('.mod-filter__button.is-selected');
				if (!anySelected) {
					filter.classList.remove('is-active');
					if (windowWidth() < 767) {
						slideUp(removeButtonParent, 300, 'none');
					}
					isFirstClick = true;
				}

				// Isotop filter
				const activeFilters = document.querySelectorAll('.mod-filter__button.is-selected');

				activeFilters.forEach((item) => {
					const dataFilter = item.getAttribute('data-filter');
					filterValues.push(dataFilter);
				});

				const filterValue = filterValues.join(', ');
				iso.arrange({ filter: filterValue });
			});
		});

		removeButton.addEventListener('click', () => {
			const allSelectedButtons = [...filter.querySelectorAll('.mod-filter__button.is-selected')];
			allSelectedButtons.forEach((button) => button.classList.remove('is-selected'));
			filter.classList.remove('is-active');
			if (windowWidth() < 767) {
				slideUp(removeButtonParent, 300, 'none');
			}
			isFirstClick = true;
			iso.arrange({ filter: '' });
		});

		dropdownTrigger.addEventListener('click', () => {
			if (windowWidth() < 767) {
				filter.classList.toggle('is-open');
			}
		});
	});
}

// ------
// Particles
// ------

const particles = document.querySelectorAll('.particles');

document.addEventListener('DOMContentLoaded', function () {
	if (0 < particles.length) {
		particlesJS('particles', {
			particles: {
				number: {
					value: 57,
					density: {
						enable: true,
						value_area: 473.4885849793636
					}
				},
				color: {
					value: '#ffffff'
				},
				shape: {
					type: 'circle',
					stroke: {
						width: 0,
						color: '#ffffff'
					},
					polygon: {
						nb_sides: 8
					}
				},
				opacity: {
					value: 0.5,
					random: false,
					anim: {
						enable: true,
						speed: 1,
						opacity_min: 0.5,
						sync: false
					}
				},
				size: {
					value: 7.891476416322726,
					random: true,
					anim: {
						enable: false,
						speed: 7.192807192807193,
						size_min: 0.1,
						sync: false
					}
				},
				line_linked: {
					enable: true,
					distance: 160.3412060865523,
					color: '#ffffff',
					opacity: 0.6,
					width: 1
				},
				move: {
					enable: true,
					speed: 6,
					direction: 'none',
					random: false,
					straight: false,
					out_mode: 'out',
					bounce: false,
					attract: {
						enable: false,
						rotateX: 600,
						rotateY: 1200
					}
				}
			},
			interactivity: {
				detect_on: 'canvas',
				events: {
					onhover: {
						enable: false,
						mode: 'repulse'
					},
					onclick: {
						enable: false,
						mode: 'push'
					},
					resize: true
				},
				modes: {
					grab: {
						distance: 400,
						line_linked: {
							opacity: 1
						}
					},
					bubble: {
						distance: 400,
						size: 40,
						duration: 2,
						opacity: 8,
						speed: 3
					},
					repulse: {
						distance: 200,
						duration: 0.4
					},
					push: {
						particles_nb: 4
					},
					remove: {
						particles_nb: 2
					}
				}
			},
			retina_detect: false
		});
	}
});

// ------
// Input
// ------

const input = document.querySelectorAll('.form-group input, .form-group textarea');
input.forEach((input) => {
	const parent = input.closest('.form-group');

	if (input.value) {
		parent.classList.add('is-focused');
	}

	input.addEventListener('focus', () => {
		parent.classList.add('is-focused');
	});

	input.addEventListener('blur', () => {
		if (!input.value) {
			parent.classList.remove('is-focused');
		}
	});
});

// ------
// Open contact form modal
// ------

const toggleContactFormModal = (toggle) => {
	document.querySelector('.contact-modal')?.classList.toggle('is-open-modal', toggle);
	toggleBodyScrollLock(toggle);
};

const contactModalTrigger = document.querySelectorAll('.contact-modal-trigger');

contactModalTrigger.forEach((trigger) => {
	trigger.addEventListener('click', (ev) => {
		toggleContactFormModal(true);
		ev.preventDefault();
	});
});

const contactModalClose = document.querySelectorAll('.contact-modal__close, .contact-modal__overlay');

contactModalClose.forEach((element) => {
	element.addEventListener('click', () => {
		toggleContactFormModal(false);
	});
});

document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		toggleContactFormModal(false);
	}
});

// ------
// Open iframe form modal
// ------

const toggleIframeFormModal = (toggle) => {
	document.querySelector('.iframe-modal')?.classList.toggle('is-open-modal', toggle);
	toggleBodyScrollLock(toggle);
};

const iframeIframeTrigger = document.querySelectorAll('.iframe-modal-trigger');

iframeIframeTrigger.forEach((trigger) => {
	trigger.addEventListener('click', (ev) => {
		toggleIframeFormModal(true);
		ev.preventDefault();
	});
});

const iframeModalClose = document.querySelectorAll('.iframe-modal__close, .iframe-modal__overlay');

iframeModalClose.forEach((element) => {
	element.addEventListener('click', () => {
		toggleIframeFormModal(false);
	});
});

document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		toggleIframeFormModal(false);
	}
});

// ------
// Sticky Popup
// ------

const stickyPopupTriggers = document.querySelector('.sticky-popup__trigger');

if (stickyPopupTriggers) {
	stickyPopupTriggers.addEventListener('click', (ev) => {
		const parentEle = ev.target.closest('.sticky-popup');
		parentEle.classList.toggle('is-open');
	});

	document.addEventListener('click', (ev) => {
		const stickyPopup = document.querySelector('.sticky-popup');

		if (!stickyPopup.contains(ev.target)) {
			stickyPopup.classList.remove('is-open');
		}
	});
}

// ------
// Card Slider
// ------

const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');
const relatedArticles = document.querySelector('.card-slider--related-articles');
const cardSliderOptions = {
	slidesPerView: 1,
	spaceBetween: 20,
	speed: 800,
	watchOverflow: true,
	freeMode: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		767: {
			slidesPerView: relatedArticles ? 2 : 2.1,
			spaceBetween: 20,
			autoHeight: false
		},
		1023: {
			slidesPerView: relatedArticles ? 3 : 2.5,
			spaceBetween: 20,
			autoHeight: false
		},
		1199: {
			slidesPerView: relatedArticles ? 4 : 3.5,
			spaceBetween: 20,
			autoHeight: false
		}
	}
};

cardSlider.forEach((el) => {
	const cardSlider = el.closest('.card-slider');

	const arrowRight = cardSlider.querySelector('.arrow-right');
	const arrowLeft = cardSlider.querySelector('.arrow-left');

	cardSliderOptions.navigation.nextEl = arrowRight;
	cardSliderOptions.navigation.prevEl = arrowLeft;
	new Swiper(el, cardSliderOptions);
});

// ------
// Hero Slider
// ------

const heroSlider = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
	slidesPerView: 1,
	spaceBetween: 20,
	speed: 800,
	watchOverflow: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	},
	autoplay: {
		delay: 4000,
		disableOnInteraction: false
	},
	autoHeight: true,
	breakpoints: {
		1023: {
			autoHeight: false
		}
	}
};

heroSlider.forEach((el) => {
	const parentEle = el.closest('.hero-module');
	const paginationElement = parentEle.querySelector('.swiper-pagination');

	heroSliderOptions.pagination.el = paginationElement;
	new Swiper(el, heroSliderOptions);
});

// **************************************************
// Scroll to top
// **************************************************

attachEvent('.scroll-to-top', 'click', (ev) => {
	ev.preventDefault();
	document.body.scrollIntoView({ behavior: 'smooth' }, true);
});

// ------
// Tabs Slider
// ------

const tabsSlider = document.querySelectorAll('[data-slider="tabs-slider"]');
const tabsContentSlider = document.querySelectorAll('[data-slider="tabs-content-slider"]');

const tabsSliderOptions = {
	slidesPerView: 1.8,
	spaceBetween: 20,
	speed: 800,
	watchOverflow: true,
	breakpoints: {
		767: {
			slidesPerView: 3.5,
			spaceBetween: 20
		},
		1023: {
			slidesPerView: 5.5,
			spaceBetween: 20
		},
		1199: {
			slidesPerView: 6,
			spaceBetween: 20
		}
	}
};

tabsSlider.forEach((el) => new Swiper(el, tabsSliderOptions));

const tabsContentSliderOptions = {
	slidesPerView: 1,
	spaceBetween: 20,
	speed: 300,
	watchOverflow: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	thumbs: {
		swiper: false
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	autoHeight: true,
	breakpoints: {
		1023: {
			autoHeight: false
		}
	}
};

tabsContentSlider.forEach((el, i) => {
	const parentEle = el.closest('.tabs-module');
	const arrowRight = parentEle.querySelector('.arrow-right');
	const arrowLeft = parentEle.querySelector('.arrow-left');

	tabsContentSliderOptions.navigation.nextEl = arrowRight;
	tabsContentSliderOptions.navigation.prevEl = arrowLeft;

	tabsContentSliderOptions.thumbs.swiper = tabsSlider[i].swiper;
	new Swiper(el, tabsContentSliderOptions);
});

// ------
// Teaser Slider
// ------

const teaserSlider = document.querySelectorAll('[data-slider="teaser-slider"]');

const teaserSliderOptions = {
	slidesPerView: 1,
	spaceBetween: 20,
	speed: 800,
	autoHeight: true,
	watchOverflow: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		767: {
			slidesPerView: 2.1,
			spaceBetween: 20,
			autoHeight: false
		},
		1023: {
			slidesPerView: 2.2,
			spaceBetween: 20,
			autoHeight: false
		},
		1199: {
			slidesPerView: 3,
			spaceBetween: 20,
			autoHeight: false
		}
	}
};

teaserSlider.forEach((el) => {
	const teaserSlider = el.closest('.teaser-slider');

	const arrowRight = teaserSlider.querySelector('.arrow-right');
	const arrowLeft = teaserSlider.querySelector('.arrow-left');

	teaserSliderOptions.navigation.nextEl = arrowRight;
	teaserSliderOptions.navigation.prevEl = arrowLeft;
	new Swiper(el, teaserSliderOptions);
});

// ------
// Fancybox
// ------
Fancybox.bind('[data-fancybox]', {});
